import { useNavigate } from "react-router-dom";

const WaiverViewerTopBar = ({ waiver }) => {

    
  const navigate = useNavigate();

  return (
    <>
        <button
            onClick={() => navigate("/business/waivers")}
            className="text-sm text-muted-foreground mb-6"
            >
        ← Back to Waivers
        </button>

        {waiver?.status === "archived" && (
        <div className="mb-6 rounded-xl border bg-blue-50 px-4 py-4 text-sm text-blue-800">
            This waiver is archived and cannot be edited.
            You can view its details, signatures and version history.
        </div>
        )}
    </>    
  );
};

export default WaiverViewerTopBar;